import React from 'react';
import {connect} from 'react-redux'
import { Button, message } from 'antd'
import DefaultDeviseTemplateContainer from '../DefaultDeviseTemplateContainer'
import TransferStudentForm from './TransferStudentForm'
import {
    editTransferStudent,
    updateTransferStudent
} from '../../actions'

import {history} from "../../router/history";

class TransferStudentContaioner extends React.Component {

    componentWillMount() {
        this.props.editTransferStudent()
    }


    render() {
        return (
            <div>
                <DefaultDeviseTemplateContainer
                    title='學生輔導紀錄資料'
                    menuButton={this.menuButton()}
                    htmlBody={<TransferStudentForm onSubmit={this.onSubmit} isLocked={this.props.isLocked}></TransferStudentForm>}
                />
            </div>
        )

    }

    onSubmit = (value) => {
        if (this.props.isLocked) {
            message.warning('此表單已鎖定，無法修改資料');
            return;
        }
        this.props.updateTransferStudent(value)
    }

    menuButton() {
        return (
            <Button onClick={() => this.goIndex()}>
                返回
            </Button>
        )
    }

    goIndex() {
        history.push('/devise_dashboard')
    }

}

const mapStateToProps = (state) => {
    const transferData = state.getIn(['TransferStudentReducers', 'data']);
    const safeTransferData = transferData && transferData.toJS ? transferData.toJS() : (transferData || {});

    return {
        isLocked: !!safeTransferData.ques_check,
    }
}

const mapDispatchToPorps = (dispatch) => ({
    editTransferStudent: () => (
        dispatch(editTransferStudent(dispatch))
    ),
    updateTransferStudent: (payload) => (
        dispatch(updateTransferStudent(dispatch,payload))
    ),
    // getStudentList: () => (
    //     dispatch(getStudentList())
    // ),
})

export default connect(mapStateToProps, mapDispatchToPorps)(TransferStudentContaioner)



// WEBPACK FOOTER //
// ./src/dashboards_redux/containers/TransferStudentContaioner/TransferStudentContaioner.jsx